/**
* Copyright (c) 2025 Bytedance, Inc. and its affiliates.
* SPDX-License-Identifier: Apache-2.0
*/
import * as __WEBPACK_EXTERNAL_MODULE_puppeteer_core_17481843__ from "puppeteer-core";
import * as __WEBPACK_EXTERNAL_MODULE__browser_finder_index_mjs_208fd54f__ from "./browser-finder/index.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__base_browser_mjs_64d751a3__ from "./base-browser.mjs";
class LocalBrowser extends __WEBPACK_EXTERNAL_MODULE__base_browser_mjs_64d751a3__.BaseBrowser {
    async launch(options = {}) {
        var _options_defaultViewport, _options_defaultViewport1;
        this.logger.info('Launching browser with options:', options);
        const { path, type } = this.getBrowserInfo(options);
        const viewportWidth = (null == options ? void 0 : null === (_options_defaultViewport = options.defaultViewport) || void 0 === _options_defaultViewport ? void 0 : _options_defaultViewport.width) ?? 1280;
        const viewportHeight = (null == options ? void 0 : null === (_options_defaultViewport1 = options.defaultViewport) || void 0 === _options_defaultViewport1 ? void 0 : _options_defaultViewport1.height) ?? 800;
        const puppeteerLaunchOptions = {
            browser: type,
            executablePath: path,
            dumpio: (null == options ? void 0 : options.dumpio) ?? false,
            headless: (null == options ? void 0 : options.headless) ?? false,
            defaultViewport: {
                width: viewportWidth,
                height: viewportHeight,
                deviceScaleFactor: 0
            },
            ...options.userDataDir && {
                userDataDir: options.userDataDir
            },
            args: [
                '--no-sandbox',
                '--mute-audio',
                '--disable-gpu',
                '--disable-http2',
                '--disable-blink-features=AutomationControlled',
                '--disable-infobars',
                '--disable-background-timer-throttling',
                '--disable-popup-blocking',
                '--disable-backgrounding-occluded-windows',
                '--disable-renderer-backgrounding',
                '--disable-window-activation',
                '--disable-focus-on-load',
                '--no-default-browser-check',
                '--disable-web-security',
                '--disable-features=IsolateOrigins,site-per-process',
                '--disable-site-isolation-trials',
                `--window-size=${viewportWidth},${viewportHeight + 90}`,
                (null == options ? void 0 : options.proxy) ? `--proxy-server=${options.proxy}` : '',
                (null == options ? void 0 : options.proxyBypassList) ? `--proxy-bypass-list=${options.proxyBypassList}` : '',
                (null == options ? void 0 : options.profilePath) ? `--profile-directory=${options.profilePath}` : '',
                ...options.args ?? []
            ].filter((item)=>{
                if ('firefox' === type) {
                    if ('--disable-features=IsolateOrigins,site-per-process' === item || item === `--window-size=${viewportWidth},${viewportHeight + 90}`) return false;
                }
                return !!item;
            }),
            ignoreDefaultArgs: [
                '--enable-automation'
            ],
            timeout: options.timeout ?? 0,
            downloadBehavior: {
                policy: 'deny'
            }
        };
        this.logger.info('Launch options:', puppeteerLaunchOptions);
        try {
            this.browser = await __WEBPACK_EXTERNAL_MODULE_puppeteer_core_17481843__.launch(puppeteerLaunchOptions);
            await this.setupPageListener();
            this.logger.success('Browser launched successfully');
        } catch (error) {
            this.logger.error('Failed to launch browser:', error);
            throw error;
        }
    }
    getBrowserInfo(options = {}) {
        const map = {
            chrome: 'chrome',
            edge: 'chrome',
            firefox: 'firefox'
        };
        let browserPath = options.executablePath;
        let browserType = options.browserType && map[options.browserType];
        if (browserPath) {
            if (!browserType) {
                const lowercasePath = browserPath.toLowerCase();
                browserType = lowercasePath.includes('chrome') ? 'chrome' : lowercasePath.includes('edge') ? 'chrome' : lowercasePath.includes('firefox') ? 'firefox' : 'chrome';
            }
        } else {
            const browserInfo = new __WEBPACK_EXTERNAL_MODULE__browser_finder_index_mjs_208fd54f__.BrowserFinder(this.logger).findBrowser();
            browserPath = browserInfo.path;
            browserType = map[browserInfo.type];
        }
        this.logger.info('Using executable path:', browserPath);
        return {
            path: browserPath,
            type: browserType
        };
    }
}
export { LocalBrowser };

//# sourceMappingURL=local-browser.mjs.map